import './styles.css'


function footer() {
  return (
    
    <footer id="footer" className="bottom">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <p className="text-lg px-4">Made with &#10084; by <a  href="https://www.jamfish.co.uk/" title="Visit Jamfish web development" target="_blank" rel="noreferrer">Jamfish</a>
            </p>
          </div>
        </div>
      </div>
    </footer>         

);
}

export default footer;
